<template>
  <div v-if="this.request" class="request_container">
    <div  class="request_head_container">
      <h3>{{this.request.type.display_name}} <span v-if="is_main">(demande principale)</span><span v-else>(demande connexe)</span> - <strong>{{this.request.decoded_status}}</strong> </h3>
    </div>
    <div class="request_body_container">
      <p class="description">{{this.request.type.description}}</p>
      <p class="time_informations">{{this.time_informations(this.request.created_at, this.request.updated_at)}}</p>
    </div>
    <!-- <hr> -->
  </div>
</template>
<script>
  export default {

    name:"Request",

    props:["request","is_main"],

    methods:
    {
      time_informations(created_at, updated_at) {
        if (moment(created_at).isSame(moment(updated_at)))
          return "Créée le " + moment(created_at).format('LLL')
        else {
          return "Créée le " + moment(created_at).format('LLL') + " et mise à jour le " + moment(updated_at).format('LLL')
        }
      },

    },

  }

</script>

<style scoped>
.request_container {
  text-align: -webkit-center;
  background-color: white;
  padding-top: 15px;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border:solid 1px lightgray;
}

.request_head_container {

}

.request_body_container {

}

.description {
  font-size:large;
}

.time_informations {
  font-size: smaller;
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Request.vue